import { Component, Input, Output } from '@angular/core';
import { AppState } from '../../../../app.service';
import { ReplicatedService } from './replicated.service';
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../common/global-variables';
import { constructInnerTableRestorePoints } from '../../dataprotection-common/common-renderers';
import { DataProtectionVariables } from '../../dataprotection-common/dataprotection-variables';
import { Modal } from '@clr/angular';
import { StorageComparator } from '../../dataprotection-common/comparator';
var $ = require('jquery');

@Component({
  selector: 'replicated-restore-points',
  providers: [
    ReplicatedService, TranslateService
  ],
  styles: [require('./replicated-vdc.scss')],
  template: require('./restore-points.html')
})

export class ReplicatedRestorePoints {
  @Input() isVisible: boolean;
  @Input() mode: string;
  @Input() selectedEntity: any = null;

  tableData:any = [];
  private subscribeHandler;
  private selected:any = [];
  private currentSelection;
  private restorePointForUpdation;
  private isRowSelected: boolean = false;
  private isOutOfPlaceRestoreModalVisible: boolean = false;
  private storageComparator = new StorageComparator('storageConsumed');
  private sizeComparator = new StorageComparator('size');
  private creationDateComparator = new StorageComparator('creationDate', 'date');
  private expiryDateComparator = new StorageComparator('expiryDate', 'date');
  private isVmsModalVisible: boolean = false;
  private vmsModalHeader: String;
  private selectedRestorePoints: any;

  constructor(public appState: AppState, public service: ReplicatedService, private translate: TranslateService) {
    translate.use(GlobalVariables.LOCALE);
  }

  ngOnInit() {
    this.getRestorePoints();
  }

  ngOnChanges(changes) {
    if (!this.isVisible) {
      this.reset();
    }
    if (changes &&
        changes.hasOwnProperty('isVisible') &&
        changes.isVisible &&
        changes.isVisible.hasOwnProperty('currentValue') &&
        changes.isVisible.currentValue) {
      this.getRestorePoints();
    }
  }

  reset() {
    this.tableData = [];
    this.isRowSelected = false;
    this.selected = [];
  }

  ngAfterViewInit() {
  }

  ngOnDestroy() {
    if(this.subscribeHandler) {
      this.subscribeHandler.unsubscribe();
    }
  }

  onGridSelectionChange(selection) {
    if (selection && selection.entityId) {
      this.currentSelection = selection;
      this.isRowSelected = true;
    } else {
      this.isRowSelected = false;
    }
  }

  onOutOfPlaceRestore(event) {
    this.isOutOfPlaceRestoreModalVisible = true;
  }

  onOutPlaceRestoreClose(event) {
    if (event && event.value) {
      this.isOutOfPlaceRestoreModalVisible = false;
      this.getRestorePoints();
    }
  }

  getRestorePoints() {
    if (this.selectedEntity && this.selectedEntity.id && this.selectedEntity.vdcId) {
      this.getReplicatedRestorePointsForVapp(this.selectedEntity.id, this.selectedEntity.vdcId);
    }
  }

  getReplicatedRestorePointsForVapp(vappId, vdcId) {
    this.subscribeHandler = this.service.getReplicatedRestorePointsForVapp(vappId, vdcId)
      .subscribe(
        tableData => {
          this.tableData = tableData;
        },
        error => this.service.logError(error, 'get restore points for vm'),
        () => this.service.logOperationCompleted('get restore points for vm')
      );
  }

  onVmsClick = (restorePoints) => {
      this.vmsModalHeader = this.translate.instant('dpsModule.replicatedVdc.vappList.vms.popupHeaderRestorePoint') + restorePoints.entityName;
      this.selectedRestorePoints = restorePoints;
      this.isVmsModalVisible = true;
  };

  onVmsModalClose = (emittedData) => {
    this.isVmsModalVisible = false;
  };
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vcd/replicated-vdc/restore-points.component.ts